import { lerp } from "../helpers"

// dist is spacing between time points
export function spaceData(data, dist) {
    let spacedData = []
    let end = data[data.length-1][0]
    let currI = 1
    for(let i = 0; i < end; i += dist) {
        let row = [i]
        while(data[currI][0] < i) {
            currI++
        }
        if(currI >= data.length) {
            currI = data.length-1
        }
        let interval = data[currI][0] - data[currI-1][0]
        let t = (i - data[currI-1][0]) / interval
        for(let k = 1; k < data[0].length; k++) {
            row.push(lerp(data[currI-1][k], data[currI][k], t))
        }
        spacedData.push(row)
    }
    return spacedData
}

// r is smoothing radius
export function averageSmoothing(data, r) {
    let newData = []
    for(let i = 1; i < data.length - 1; i++) {
        // current row
        let row = []
        row.push(data[i][0])
        for(let k = 1; k < data[0].length; k++) {
            row.push(data[i][k])
        }
        // initialize start and end points
        let totalPoints = 1
        let startPoint = i-1
        let endPoint = i+1
        // add points to the left
        while(startPoint >= 0 && Math.abs(data[i][0] - data[startPoint][0]) < r) {
            for(let k = 1; k < data[0].length; k++) {
                row[k] += data[startPoint][k]
            }
            startPoint-=1
            totalPoints+=1
        }
        // add points to the right
        while(endPoint < data.length && Math.abs(data[endPoint][0] - data[i][0] < r)) {
            for(let k = 1; k < data[0].length; k++) {
                row[k] += data[endPoint][k]
            }
            endPoint+=1
            totalPoints+=1
        }

        for(let k = 1; k < data[0].length; k++) {
            row[k] /= totalPoints
        }
        newData.push(row)
    }
    return newData
}

export function getExtremas(data, index, threshold, minsOnly = false) {
    let points = []
    for(let i = 1; i < data.length-1; i++) {
        if((data[i][index] - data[i-1][index]) * (data[i+1][index]-data[i][index]) < 0) {
            if(points.length > 0) {
                if(data[i][0] - points[points.length-1][0] > threshold) {
                    if(minsOnly) {
                        if((data[i][index]-data[i-1][index]) < 0) {
                            points.push([data[i][0], data[i][index]])
                        }
                    }
                    else {
                        points.push([data[i][0], data[i][index]])
                    }
                }
            }
            else {
                points.push([data[i][0], data[i][index]])
            }
        }
    }
    return points
}

export function getDerivative(data) {
    let der = []
    for(let i = 1; i < data.length; i++) {
        let row = [data[i][0]]
        for(let k = 1; k < data[0].length; k++) {
            let value = (data[i][k] - data[i-1][k]) / (data[i][0] - data[i-1][0])
            row.push(value)
        }
        der.push(row)
    }
    return der
}

export function standardDeviation(data) {
    let averages = average(data)
    let stds = []
    for(let k = 0; k < data[0].length; k++) {
        stds.push(0)
    }
    for(let i = 0; i < data.length; i++) {
        for(let k = 0; k < data[0].length; k++) {
            stds[k] += Math.pow((data[i][k]-averages[k]), 2)
        }
    }
    for(let k = 0; k < data[0].length; k++) {
        stds[k] /= data.length
        stds[k] = Math.sqrt(stds[k])
    }
    return stds
}

export function average(data) {
    let averages = []
    for(let k = 0; k < data[0].length; k++) {
        averages.push(0)
    }
    for(let i = 0; i < data.length; i++) {
        for(let k = 0; k < data[0].length; k++) {
            averages[k] += data[i][k]
        }
    }
    for(let k = 0; k < data[0].length; k++) {
        averages[k] /= data.length
    }
    return averages
}

export function findBestPoints(start, end, dist, extremas, weights) {
    let data = []
    for(let tick = start; tick < end; tick += dist) {
        let error = 0
        // go through each joint
        for(let k = 0; k < extremas.length; k++) {
            // find closest point for this joint
            let closest = extremas[k][0]
            let closestDist = Math.abs(closest-tick)
            for(let j = 0; j < extremas[k].length; j++) {
                if(Math.abs(tick-extremas[k][j]) < closestDist) {
                    closest = extremas[k][j]
                    closestDist = Math.abs(tick-extremas[k][j])
                }
            }
            // set error
            error += (closestDist * closestDist) * weights[k]
        }
        data.push([tick, error])
    }
    return data
}

export function clusterPoints(points, minDistance) {
    let pts = []
    points.forEach(pt => {
        pts.push(pt)
    })
    for(let i = 0; i < pts.length; i++) {
        let minIndex = i
        for(let k = i; k < pts.length; k++) {
            if(pts[k] < pts[minIndex]) {
                minIndex = k
            }
        }
        let temp = pts[i]
        pts[i] = pts[minIndex]
        pts[minIndex] = temp
    }
    
    for(let i = 0; i < pts.length - 1; i++) {
        if((pts[i+1] - pts[i]) < minDistance) {
            let newPoint = (pts[i+1] + pts[i]) / 2
            pts.splice(i, 2, newPoint)
            i--
        }
    }

    return pts
}